export default "__VITE_ASSET__DhGY4A4A__"